import { FC } from 'react';
import {
  Button,
  Divider,
  Icon,
  RemoveAlertDialog,
  Text,
  useDisclosure,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { usePostOfferToAnva } from '@flows/src/api/anva-flows/postOfferToAnva';
import SendAnvaOfferStatus from '@flows/src/components/flow-products/quotes/basket/actions/SendAnvaOfferStatus';
import { InsurancePoliciesDocumentList } from '@flows/src/components/flow-products/quotes/basket/actions/InsurancePoliciesDocumentList';
import { AnvaErrorAlert } from '@flows/src/components/flow-products/quotes/basket/actions/anva-party-creation-modal/AnvaErrorAlert';

interface Props {
  sessionId: string;
  isPlural?: boolean;
}

const SelectionOverviewAnvaOfferButton: FC<Props> = ({
  sessionId,
  isPlural,
}) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { data, mutate, isError, error, status, isSuccess } =
    usePostOfferToAnva({});
  const title = isPlural
    ? t('FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_PLURAL')
    : t('FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_SINGULAR');
  const handleClick = () => {
    onOpen();
    try {
      if (!isSuccess) {
        mutate({ sessionId });
      }
    } finally {
      // onClose();
    }
  };

  return (
    <>
      <RemoveAlertDialog
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        onConfirm={onClose}
        confirmButtonText={t('CLOSE')}
        hideCancelButton
        variant="ghost"
        size="2xl"
      >
        <VStack spacing="4" align="stretch">
          <Text textStyle="smallBody" color="gray.500">
            {t('FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_DESCRIPTION')}
          </Text>
          <Divider color="gray.50" />
          {isError ? (
            <AnvaErrorAlert error={error as Error} />
          ) : (
            <SendAnvaOfferStatus status={status} isPlural={isPlural} />
          )}
          {data &&
            [...data.insurance_policies, ...data.policy_packages].length >
              0 && <InsurancePoliciesDocumentList data={data} />}
        </VStack>
      </RemoveAlertDialog>
      <Button
        onClick={handleClick}
        leftIcon={
          <Icon
            name={
              isSuccess
                ? 'GeneralStatusSuccessCheckmark'
                : 'GeneralActionsSendTo'
            }
          />
        }
        variant={isSuccess ? 'successGhost' : 'secondary'}
      >
        {title}
      </Button>
    </>
  );
};

export default SelectionOverviewAnvaOfferButton;
